import { api } from './api'
import { ConsultationTerminologySystem } from '../types/consultation'

export interface TerminologySearchResult {
  system: ConsultationTerminologySystem
  code: string
  version?: string
  display: string
  kind?: string
  chapterCode?: string
  parentCode?: string
  icd10Mappings?: string[]
}

export const terminologyService = {
  search: async (
    system: ConsultationTerminologySystem,
    query: string,
    options?: { version?: string; limit?: number },
  ): Promise<TerminologySearchResult[]> => {
    const params: Record<string, string | number> = {
      system,
      q: query,
    }
    if (options?.version) {
      params.version = options.version
    }
    if (options?.limit) {
      params.limit = options.limit
    }

    const response = await api.get<TerminologySearchResult[]>('/terminologies', { params })
    return response.data
  },
}

